import React from "react";
import { useBreakpoint } from "@chakra-ui/react";
import { useLoaderData, useRevalidator } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import TaskListTableView from "./TaskListTableView";
import TaskListCardView from "./TaskListCardView";

function requestToAPIParams(request) {
  const params = new URL(request.url).searchParams;
  const result = {};
  const map = { show: "state" };

  // eslint-disable-next-line array-callback-return
  Array.from(params.entries()).map(([key, value]) => {
    let values = key === "show" ? value.split(",") : [value];
    const _key = key in map ? map[key] : key;
    // eslint-disable-next-line array-callback-return
    values.map((_value) => {
      if (_key in result) {
        if (Array.isArray(result[_key])) {
          result[_key].push(_value);
        } else {
          result[_key] = [result[_key], _value];
        }
      } else {
        result[_key] = _value;
      }
    });
  });
  return result;
}
// Not used by router; kept for potential future usage
export async function AppintmentLoader({ request }) {
  const params = requestToAPIParams(request);
  params["page"] = params["page"] || 1;
  return params;
}

export default function Appointment() {
  const bp = useBreakpoint({ ssr: false });
  const tasks = useLoaderData();
  const revalidator = useRevalidator();
  const Component =
    {
      base: TaskListCardView,
      sm: TaskListCardView,
      md: TaskListCardView,
      lg: TaskListTableView,
    }[bp] || TaskListTableView;
  return (
    <Component
      tasks={tasks}
      onRefresh={() => revalidator.revalidate()}
      title="Randevular"
      icon={FaCalendarAlt}
      paginationPath="randevular"
    />
  );
}
